import React from "react"
import ReactDOM from "react-dom"
import Meme from "./Meme"
import "./memeGEN.css"
import Header from "./Header"

ReactDOM.render(<>
<Header/>
<Meme />
</>,
document.getElementById("root"))
